export enum EntryFeeTierOperatorEnum {
  GT = ">",
  GTE = ">=",
  LT = "<",
  LTE = "<="
}
